var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorsponsored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 13,
    viewBox: "0 0 23 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 23,
    height: 13,
    rx: 3,
    fill: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99 10L6.87 3H8.31L11.17 10H9.83L9.06 8.05H6.04L5.27 10H3.99ZM6.44 7.04H8.68L7.56 4.2L6.44 7.04ZM13.0584 8.9H14.3984C14.7384 8.9 15.0551 8.84 15.3484 8.72C15.6418 8.6 15.8984 8.43 16.1184 8.21C16.3384 7.99 16.5084 7.73667 16.6284 7.45C16.7551 7.16333 16.8184 6.85 16.8184 6.51C16.8184 6.17 16.7551 5.85333 16.6284 5.56C16.5084 5.26667 16.3384 5.01333 16.1184 4.8C15.8984 4.58 15.6418 4.41 15.3484 4.29C15.0551 4.16333 14.7384 4.1 14.3984 4.1H13.0584V8.9ZM11.8284 10V3H14.3984C14.9251 3 15.4118 3.09 15.8584 3.27C16.3051 3.44333 16.6951 3.69 17.0284 4.01C17.3618 4.32333 17.6218 4.69333 17.8084 5.12C17.9951 5.54667 18.0884 6.01 18.0884 6.51C18.0884 7.01 17.9951 7.47333 17.8084 7.9C17.6218 8.32 17.3618 8.68667 17.0284 9C16.6951 9.31333 16.3051 9.56 15.8584 9.74C15.4118 9.91333 14.9251 10 14.3984 10H11.8284Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorsponsored);
export default __webpack_public_path__ + "static/media/distributorsponsored.da5806df23010f6e201f2b8b6372b153.svg";
export { ForwardRef as ReactComponent };